import * as React from "react";
import * as ReactDOM from "react-dom";

import "next-react/src/scss/main.scss";
import { NextManagerApp } from "next-react/src/entry/NextManagerApp";

document.title = "Next Practice Manager";

ReactDOM.render(<NextManagerApp />, document.getElementById("app"));
